import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
require('parsley');
require('datatables.net');
require('datatablesResponsive');

let scope:Element = document.querySelector('#partnerportal_dashboard');
if (scope){
	try {
		$(document).ready(function() {
             let url;
        if (window.location.hostname === 'localhost') {
             let url = '/dummy-data/partneradmin.json';
            }
        else {
           let url = '/bin/services/new/getpartnerportalApplication ';
        }
		$('#partnerportal_dashboard').DataTable({
			"processing" : true,
			"ajax" : {
				"url" : '/bin/services/new/getpartnerportalApplication',
				// "url" : '/dummy-data/partneradmin.json',
				dataSrc : ''
			},
			"columns" : [ {
				"data" : "id"
			}, {
				"data" : "companyname"
			}, {
				"data" : "companyregistrationno"
			}, {
				"data" : "buainesindustry"
			},
			{
				"data" : "title"
			}, 
			{
				"data" : "adminFirstName"
			}, 
			{
				"data" : "adminLastName"
			}, 
			{
				"data" : "adminemail"
			}, 
			{
				"data" : "countryCode"
			}, 
			{
				"data" : "admincontact"
			}, 
			{
				"data" : "companyaddress"
			},
			{
				"data" : "country"
			}, 
			{
				"data" : "state"
			}, 
			{
				"data" : "city"
			}, 
			{
				"data" : "postalCode"
			}, 
			{
				"data" : "postalBox"
			}, 
			{
				"data" : "noofmembers"
			},{
				"data" : ""
			}, {
				"data" : "sourceOfReference"
			},{
				"data" : "submissiontimestamp"
			}, ]
			,
                    "columnDefs": [{
                        "targets":17,
                        "data": null,
                        "mData": null,
                        "bSortable": false,
                        "mRender": function (data:any, type:any, full:any) {
							 {
                                return '<a href=/bin/services/new/fetchPartnerPortalUploadData?imageId='+full.attachment+' target="_blank">View Attachment</a>'
                            }
                        }
                    }]
		});
	});

	} catch(e) {console.error(e);}
} 